export default __webpack_public_path__ + "static/1301-1f66bcac5980e07f40f83ad34e733954.gif";